import BaseUISystem from './BaseUISystem';
import DataConflictsMenuHandler from './Menu/DataConflictsMenuHandler';
import GBCDisconnectedMenuHandler from './Menu/GBCDisconnectedMenuHandler';

export default class LuckyTurnipUISystem extends BaseUISystem {
    public init(): void {
        this.handlers = [new GBCDisconnectedMenuHandler(this), new DataConflictsMenuHandler(this)];
    }
}
